import { render, staticRenderFns } from "./CaseFieldItem.vue?vue&type=template&id=25e8f8cd&scoped=true"
import script from "./CaseFieldItem.vue?vue&type=script&lang=ts"
export * from "./CaseFieldItem.vue?vue&type=script&lang=ts"
import style0 from "./CaseFieldItem.vue?vue&type=style&index=0&id=25e8f8cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e8f8cd",
  null
  
)

export default component.exports